import React from 'react';
import styles from './portfolioOverviewSection.module.scss';

// Each column: { label } plus one of { value }, { lines: string[] }, or { items: string[] };
// optional { wide }, optional { itemsSingleLine } on items columns (fit-content + one line per item, like My role).
// optional section prop { bulleted } — disc bullets on all column bodies (e.g. Campus Dive preview).

function OverviewColumnBody({ column, bulleted }) {
  if (column.value != null) {
    if (bulleted) {
      return (
        <ul className={styles.listBulletedTight}>
          <li>{column.value}</li>
        </ul>
      );
    }
    return <p className={styles.value}>{column.value}</p>;
  }
  if (column.lines) {
    if (bulleted) {
      return (
        <ul className={styles.listBulletedTight}>
          {column.lines.map((line, idx) => (
            <li key={idx}>{line}</li>
          ))}
        </ul>
      );
    }
    return (
      <div className={styles.lines}>
        {column.lines.map((line, idx) => (
          <p key={idx}>{line}</p>
        ))}
      </div>
    );
  }
  if (column.items) {
    if (bulleted) {
      const listClass = column.itemsSingleLine ? styles.listBulletedTight : styles.listBulleted;
      return (
        <ul className={listClass}>
          {column.items.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      );
    }
    const listClass = column.itemsSingleLine ? styles.listSingleLine : styles.list;
    return (
      <ul className={listClass}>
        {column.items.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
    );
  }
  return null;
}

export default function PortfolioOverviewSection({
  columns,
  ariaLabel = 'Project overview',
  className = '',
  bulleted = false,
}) {
  return (
    <section className={`${styles.overview} ${className}`.trim()} aria-label={ariaLabel}>
      {columns.map((column, index) => {
        const colClass = column.wide ? `${styles.col} ${styles.colWide}` : styles.col;
        return (
          <div key={`${column.label}-${index}`} className={colClass}>
            <p className={styles.label}>{column.label}</p>
            <OverviewColumnBody column={column} bulleted={bulleted} />
          </div>
        );
      })}
    </section>
  );
}
